<template>
  <section>
    <b-collapse
      class="card filter-border calendar-visible"
      animation="slide"
      aria-id="filter-content"
      :open="false">
      <template #trigger="props">
        <div
          class="card-header"
          :class="props.open ? 'filter-border-header-open' : 'filter-border-header-close'"
          role="button"
          aria-controls="filter-content">
          <p class="card-header-title">Filtros</p>
          <a class="card-header-icon text-not-underline">
            <b-icon :icon="props.open ? 'fas fa-angle-up' : 'fas fa-angle-down'" />
          </a>
        </div>
      </template>

      <div class="appraisal-filter-container is-fluid">
        <div id="filter-content" class="container">
          <b-field grouped group-multiline position="is-centered" class="m-4 p-2" expanded>
            <b-field label="Fecha" custom-class="has-text-weight-normal" class="mb-4" expanded>
              <b-datepicker
                id="appraisal-filter-fecha"
                v-model="filtroFecha"
                locale="es-ES"
                placeholder="Clic para seleccionar"
                icon="calendar"
                icon-pack="fa"
                range
                size="is-small"
                trap-focus
                @input="onChangeFecha" />
            </b-field>
            <b-field label="Estado" custom-class="has-text-weight-normal" class="mb-4" expanded>
              <b-taginput
                id="appraisal-filter-estado"
                v-model="statesSelected"
                :data="statesOptions"
                autocomplete
                :allow-new="false"
                :open-on-focus="true"
                field="name"
                icon="label"
                rounded
                size="is-small"
                :has-counter="false"
                @input="onChangeState"
                @typing="getFilteredStatesOptions" />
            </b-field>
            <b-field id="field-buyer" label="Comprador" custom-class="has-text-weight-normal" class="mb-4" expanded>
              <b-taginput
                id="appraisal-filter-client"
                v-model="buyerSelected"
                :data="buyerOptions"
                autocomplete
                :allow-new="false"
                :open-on-focus="true"
                field=""
                icon="label"
                rounded
                size="is-small"
                :has-counter="false"
                @input="onChangeBuyer"
                @typing="getFilteredBuyerOptions" />
            </b-field>
            <b-field label="Tipo" custom-class="has-text-weight-normal" class="mb-4" expanded>
              <b-taginput
                id="appraisal-filter-sales-type"
                v-model="typesSelected"
                :data="typesOptions"
                autocomplete
                :allow-new="false"
                :open-on-focus="true"
                field=""
                icon="label"
                rounded
                size="is-small"
                :has-counter="false"
                @input="onChangeTypes"
                @typing="getFilteredTypesOptions" />
            </b-field>
            <b-field label="Usuario" custom-class="has-text-weight-normal" class="mb-4" expanded>
              <b-checkbox
                id="appraisal-filter-usuario"
                v-model="filtroUsuario"
                true-value="Todos"
                size="is-small"
                false-value="Yo"
                @input="onChangeUsuario">
                {{ filtroUsuario }}
              </b-checkbox>
            </b-field>
          </b-field>
        </div>
      </div>
    </b-collapse>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { getInvestors } from '@/application/services/api-clients/investors';
import appraisalSalesTypes from '@/domain/constants/appraisal-sales-types';

const states = [
  { name: 'Guardado', value: 'SAVED' },
  { name: 'Procesado', value: 'PROCESSED' },
  { name: 'Por enmendar', value: 'TO_AMEND' }
];

export default {
  name: 'AppraisalHistoryFilter',
  data() {
    return {
      statesSelected: states,
      statesOptions: states,
      buyers: [],
      buyerOptions: [],
      buyerSelected: [],
      types: [],
      typesOptions: [],
      typesSelected: [],
      filtroUsuario: 'Todos',
      filtroFecha: [],
      appraisalSalesTypes
    };
  },
  computed: {
    ...mapGetters({ investors: 'endorsementModule/investors' })
  },
  async mounted() {
    if (this.investors.length === 0) {
      const investors = await getInvestors();
      const investorsNames = [];
      let investorsResult = JSON.parse(JSON.stringify(investors));
      investors.forEach(investor => {
        if (investorsNames.includes(investor.name)) {
          investorsResult = investorsResult.filter(inv => inv.name !== investor.name);
          this.buyerSelected.push(investor.name.toUpperCase());
        }
        investorsNames.push(investor.name);
      });
      this.setInvestors(investorsResult);
    } else {
      this.investors.forEach(investor => {
        this.buyerSelected.push(investor.name.toUpperCase());
      });
    }
    this.buyerOptions = this.buyerSelected;
    this.buyers = this.buyerSelected;

    this.appraisalSalesTypes.forEach(type => {
      this.typesSelected.push(type.name.toUpperCase());
    });
    this.typesOptions = this.typesSelected;
    this.types = this.typesSelected;

    this.onChangeState(this.statesSelected);
    this.onChangeBuyer(this.buyerSelected);
    this.onChangeTypes(this.typesSelected);
    this.onChangeUsuario(this.filtroUsuario);
  },
  methods: {
    ...mapActions({ setInvestors: 'endorsementModule/setInvestors' }),
    onChangeState(event) {
      const eventName = 'filter-estado-actualizado';
      const names = Array.from(event).map(a => a.value);
      this.$emit(eventName, { eventName, value: names });
    },
    onChangeBuyer(event) {
      const eventName = 'filter-comprador-actualizado';
      this.$emit(eventName, { eventName, value: event });
    },
    onChangeTypes(event) {
      const eventName = 'filter-tipo-venta-actualizado';
      this.$emit(eventName, { eventName, value: event });
    },
    onChangeUsuario(event) {
      const eventName = 'filter-usuario-actualizado';
      this.$emit(eventName, { eventName, value: event });
    },
    onChangeFecha(event) {
      const eventName = 'filter-fecha-actualizado';
      this.$emit(eventName, { eventName, value: event });
    },
    getFilteredStatesOptions(text) {
      this.statesOptions = states.filter(option => {
        return option.name
          .toString()
          .toLowerCase()
          .indexOf(text.toLowerCase()) >= 0;
      });
    },
    getFilteredBuyerOptions(text) {
      this.buyerOptions = this.buyers.filter(option => {
        return option
          .toString()
          .toLowerCase()
          .indexOf(text.toLowerCase()) >= 0;
      });
    },
    getFilteredTypesOptions(text) {
      this.typesOptions = this.types.filter(option => {
        return option
          .toString()
          .toLowerCase()
          .indexOf(text.toLowerCase()) >= 0;
      });
    }
  }
};
</script>

<style scoped>
.appraisal-filter-container {
  display: flex;
  align-items: center;
  align-content: space-between;
  justify-content: center;
  flex-flow: wrap;
}
.text-not-underline {
  text-decoration: none !important;
}
.filter-border {
  box-shadow: 0px 0px; border-radius: 40px; border: 1px solid #00CCD1;
}
.calendar-visible {
  overflow: visible !important;
}
</style>
<style>
div.autocomplete {
  width: min-content;
}
</style>
